/**
 * Google Tag Manager initialization
 * Only initializes GTM after user consent via cookie consent banner
 */

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

/**
 * Initialize Google Tag Manager
 * This should only be called after user accepts cookies
 */
export function initGTM(): void {
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;

  if (!gtmId) {
    console.warn(
      "GTM ID not found. Please set NEXT_PUBLIC_GTM_ID in your environment variables."
    );
    return;
  }

  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];

    // Check if GTM script is already loaded
    const existingScript = document.querySelector(
      `script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`
    );
    if (existingScript) {
      return;
    }

    // Create and inject GTM script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    // Create noscript fallback
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}

/**
 * Push data to GTM dataLayer
 * Use this for custom events after GTM is initialized
 */
export function pushToDataLayer(data: Record<string, unknown>): void {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(data);
  }
}





